
import React from 'react';
import styled from 'styled-components'
import * as Icons from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import getInTouch from '../images/getInTouch.svg';

const Image = styled.img`
    max-width: 250px;
    margin: 0 auto;
    padding: 20px 0;

    @media (min-width: 1150px) {
        max-width: 450px;
    }
`
const Content = styled.p`
    padding: 10px;
    font-size: 16px;
    max-width: 670px;
    margin: 10px auto;
    line-height: 26px;
    box-sizing: border-box;
    
    @media (min-width: 1150px) {
        font-size: 20px;
    }

    a {
        color: #dc9a98;
    }
`
const FooterContainer = styled.footer`
    padding: 50px 0 100px;
`

const SocialIcons = styled.div`

    svg  {
        padding: 10px;
    }
`

const Podcast = () => {
    return (
        <FooterContainer>
            <Image src={getInTouch} alt="Get in touch"/>
            <Content>
                We would love to hear any feedback or requests you might have, please get in touch with us via our social media or email us on <a href="mailTo:hello@dermatologyukthepodcast.com">hello@dermatologyukthepodcast.com</a>
            </Content>
            <SocialIcons>
                <a href="https://www.instagram.com/dermatologyukthepodcast/" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={Icons.faInstagram} size="2x" />
                </a>
                <a href="https://twitter.com/dermukpodcast" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={Icons.faTwitter} size="2x" />
                </a>
                <a href="https://www.facebook.com/dermatologyukthepodcast" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={Icons.faFacebook} size="2x" />
                </a>
            </SocialIcons>
        </FooterContainer>
    );
};

export default Podcast;
